<template>
  <div>
    <j-modal :visible="visible"
             width="60%"
             title="设备详情"
             :footer="null"
             @cancel="cancelModal">
      <a-divider orientation="left"><b>设备基本档案</b></a-divider>
      <div style="padding: 0 10px">
        <DetailInfo :formLayout="formLayout" :columnNum="3" />
      </div>
      <a-divider orientation="left"><b>设备变更记录</b></a-divider>
      <BaseTable ref="baseTable"
                 v-if="visible"
                 :tableSetting="tableSetting"
                 @searchReset="searchReset"
                 :mainTable="mainTable"
                 :tableColumns="columns"
                 :tableData="tableData" />
    </j-modal>
  </div>
</template>

<script>
import { BaseTable } from '@comp/mtcModule'
import { efcOcnDeviceChangeList, efcOcnDeviceQueryById } from '@api/online'
import pageConfig from '../equipmentListConfig'
import DetailInfo from '@comp/DetailInfo/DetailInfo'
import { equipmentInfo } from '@views/onlineModal/formItemConfig'

export default {
  name: 'detailModal',
  title: '设备详情',
  components: { BaseTable, DetailInfo },
  data() {
    return {
      visible: false,
      tableSetting: {
        isShowAlert: false,
        isShowTools: false
      },
      queryParam: {},
      mainTable: 'efc_ocn_device_change_record',
      columns: pageConfig.detailColumns,
      tableData: params => this.getTableData(params),
      // 设备id
      deviceId: '',
      // 详情布局
      formLayout: []
    }
  },
  methods: {
    // 列表数据接口
    getTableData(base) {
      if (!this.deviceId) return
      let params = {
        ...base,
        deviceId: this.deviceId,
        ...this.queryParam
      }
      return efcOcnDeviceChangeList(params)
    },
    // 重置查询条件
    searchReset() {
      this.queryParam = {}
      this.refresh()
    },
    // 打开模态框
    openModal({ id }) {
      this.deviceId = id
      this.visible = true
      this.setBaseInfo()
    },
    // 设置详情基本信息布局
    setBaseInfo() {
      let formLayout = [...equipmentInfo]
      efcOcnDeviceQueryById({ id: this.deviceId }).then(res => {
        let data = res.result
        formLayout.map(ele => ele.value = data[ ele.field ])
        this.formLayout = [...formLayout]
      })
    },
    // 关闭模态框
    cancelModal() {
      this.visible = false
    },
    // 确认提交模态框
    submitModal() {

    }
  }
}
</script>